export default __webpack_public_path__ + "static/bot204-2f64ef8e66d7aa0ca7865c6445f5272e.jpeg";